import { logger } from "@moodys/mdc-frontend.services.logger";

import { MenuNodeType } from "components/Menu/model";

import { MenuExpansionNode } from "../MenuExpansionNode";
import { MenuLinkNode } from "../MenuLinkNode";
import { MenuSectionLabelNode } from "../MenuSectionLabelNode";
import { MenuSectionNode } from "../MenuSectionNode";

export interface SubMenuNodeBaseProps {
  focus: boolean;
  isMobile: boolean;
  containerLinkText?: string;
  expansionLinkText?: string;
}

interface SubMenuNodeProps extends SubMenuNodeBaseProps {
  childNode: MenuNodeType.Any;
}

export const SubMenuNode = ({
  childNode,
  containerLinkText,
  expansionLinkText,
  focus,
  isMobile,
}: SubMenuNodeProps) => {
  if ("href" in childNode)
    return (
      <MenuLinkNode
        node={childNode}
        containerLinkText={containerLinkText}
        expansionLinkText={expansionLinkText}
        focus={focus}
      />
    );

  switch (childNode.nodeType) {
    case "section":
      return (
        <MenuSectionNode
          node={childNode}
          isMobile={isMobile}
          containerLinkText={containerLinkText}
          expansionLinkText={expansionLinkText}
          focus={focus}
        />
      );
    case "expansion":
      return (
        <MenuExpansionNode
          node={childNode}
          isMobile={isMobile}
          containerLinkText={containerLinkText}
          expansionLinkText={expansionLinkText}
          focus={focus}
        />
      );
    case "sectionLabel":
      return <MenuSectionLabelNode titleKey={childNode.titleKey} />;
  }

  const error = new Error("Invalid node!");
  logger.error({ error, data: childNode });
  return null;
};
